import { Select, Box, Grid, MenuItem, Typography, makeStyles } from "@material-ui/core";
import { COLORS } from "../../theme/colors";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getData } from "../../services";
import Menu from "../../components/menu/Menu";
import { HorizontalTabs } from "../../components/horizontalTabs";
import { GlanceTab } from "../building/tabsV2/glance/GlanceTab";
import { PropertiesTab } from "../building/tabsV2/properties/PropertiesTab";
import { TenantsTab } from "../building/tabsV2/tenants/TenantsTab";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    position: "relative",
  },
  address: {
    lineHeight: 2.5,
    marginLeft: theme.spacing(1),
    color: COLORS.darks[1],
  },
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    marginLeft: theme.spacing(4.2),
    height: "100%",
    boxSizing: "border-box",
    flexGrow: 1,
  },
}));

export const ComplexPage = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [buildings, setBuildings] = useState([]);
  const [complexes, setComplexes] = useState([]);
  const [complex, setComplex] = useState();
  const [building, setBuilding] = useState();
  const [tab, setTab] = useState(0);

  const TabComponent = [GlanceTab, PropertiesTab, TenantsTab][tab];

  useEffect(() => {
    getData("/praas/v2/complexes/", setComplexes);
    getData("/praas/v2/buildings/without-complex/", setBuildings);
  }, []);

  useEffect(() => {
    getData(`/praas/v2/complexes/${id}/`, setComplex);
  }, [id]);

  useEffect(() => {
    if (searchParams.get("building")) {
      getData(`/praas/v1/buildings/${searchParams.get("building")}/`, setBuilding);
    } else {
      setBuilding(null);
    }
  }, [searchParams.get("building")]);

  return (
    <Grid className={classes.rootContainer} container>
      <Menu navigate={navigate} selectedComplex={id} complexes={complexes} buildings={buildings} />
      {complex && (
        <Box className={classes.root}>
          <Grid container>
            <Typography variant="h2" style={{ fontWeight: 400 }}>
              {complex.name}
            </Typography>
            <div className={classes.address}>
              <Select
                style={{ fontSize: 16 }}
                value={searchParams.get("building") ?? 0}
                onChange={(event) => {
                  setSearchParams(
                    event.target.value && {
                      building: event.target.value,
                    }
                  );
                }}
              >
                <MenuItem value={0} style={{ fontSize: 14 }}>
                  All Buildings
                </MenuItem>
                {complex.buildings.map((building) => (
                  <MenuItem key={building.id} value={building.id} style={{ fontSize: 14 }}>
                    {building.address}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </Grid>

          <HorizontalTabs
            tab={tab}
            setTab={setTab}
            tabNames={["At a Glance", "Properties", "Tenants"]}
          />
          <TabComponent complex={complex} building={building} />
        </Box>
      )}
    </Grid>
  );
};
